import {
  ADMIN_LOGOUT_SUCCESS,
  ADMIN_LOGOUT_FAILED,
  RESET_ADMIN_LOGOUT,
  LOADING_ADMIN_LOGOUT,
  NETWORK_ERROR_ADMIN_LOGOUT,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_ADMIN_LOGOUT:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case ADMIN_LOGOUT_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case ADMIN_LOGOUT_SUCCESS:
      return {
        ...state,
        isLoading: true,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_ADMIN_LOGOUT:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_ADMIN_LOGOUT:
      return (state = initialState);
    default:
      return state;
  }
};
